import { FormControl, InputGroup } from 'react-bootstrap';
import './HelpCenterHeroSection.scss';

function HelpCenterHeroSection() {
  return (
    <section className="d-flex flex-column help-center">
      <div className="help-center-title">Help Center</div>
      {/* <div className="help-center-search"> temporary removed forMVP
        <InputGroup className="mb-3">
          <FormControl placeholder="Enter your request/question" aria-label="request" aria-describedby="basic-addon1" />
          <InputGroup.Append>
            <button type="button" className="help-center-search-button">
              <i data-test="fa" className="fas fa-search"></i>
            </button>
          </InputGroup.Append>
        </InputGroup>
      </div>
      <div className="help-center-sub-title">
        <strong>Ask us a question</strong>, or search for key words
      </div>*/}
    </section>
  );
}
export default HelpCenterHeroSection;
